import SkillDetailPanel from './SkillDetailPanel';

export default SkillDetailPanel;
